/**
 * Labstep
 *
 * @module prosemirror/extensions/alignment
 * @desc Alignment management
 */

import type { LabstepExtension } from '../types';
import { setTextAlign } from './commands';

export const ExtensionAlignment: LabstepExtension = {
  keymap: {
    'Mod-Shift-l': setTextAlign('left'),
    'Mod-Shift-e': setTextAlign('center'),
    'Mod-Shift-r': setTextAlign('right'),
    'Mod-Shift-j': setTextAlign('justify'),
  },
};
